import { render } from "./MediaInfoOldPopUp.vue?vue&type=template&id=60173692&scoped=true&ts=true"
import script from "./MediaInfoOldPopUp.vue?vue&type=script&lang=ts"
export * from "./MediaInfoOldPopUp.vue?vue&type=script&lang=ts"

import "./MediaInfoOldPopUp.vue?vue&type=style&index=0&id=60173692&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60173692"]])

export default __exports__